module.exports = __webpack_public_path__ + "static/media/ccNewLogoWhite.e6f586f3.png";